module.exports = __webpack_public_path__ + "img/album13_07.f23a795f.jpg";